import * as React from "react";
const SvgArrowUpSmall24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 8,
        fill: "black",
        viewBox: "0 0 12 8"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m11.707 5.793-1.414 1.414L6 2.914 1.707 7.207.293 5.793 6 .086l5.707 5.707Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowUpSmall24Px;
